/**
 * Time-boxed dismissal for install prompts. A dismiss used to hide the prompt
 * forever, so anyone who closed it once never saw it again, even after they
 * moved to a laptop. Now it snoozes for {@link EXTENSION_PROMPT_SNOOZE_DAYS}.
 *
 * Storage access can throw (private mode, blocked site data), so every read and
 * write is wrapped. A failed read counts as "not snoozed".
 */
export const EXTENSION_PROMPT_SNOOZE_DAYS = 14;
const DAY_MS = 24 * 60 * 60 * 1000;

/** True while a snooze written under `key` is still in force. */
export function isPromptSnoozed(
	key: string,
	now: number = Date.now(),
): boolean {
	try {
		const raw = localStorage.getItem(key);
		if (!raw) return false;
		const until = Number(raw);
		// The legacy value "1" meant "dismissed forever". Treat it as expired so
		// those visitors see the prompt again, now with the 14-day snooze.
		if (!Number.isFinite(until) || until < 1e12) return false;
		return until > now;
	} catch {
		return false;
	}
}

export function snoozePrompt(
	key: string,
	now: number = Date.now(),
	days: number = EXTENSION_PROMPT_SNOOZE_DAYS,
): void {
	try {
		localStorage.setItem(key, String(now + days * DAY_MS));
	} catch {
		// Best effort only: the click still hides the prompt for this page view.
	}
}
